export enum HireBikesSlaTexts {
  ParkedDangerously = '1 hr',
  BlockingCrossing = '1 hr',
  BlockingRoad = '4 hrs',
  OvercrowdedParkingBay = '4 hrs',
  SomethingElse = '4 hrs',
}

export enum HireScootersSlaTexts {
  ParkedDangerously = '1 hr',
  BlockingCrossing = '1 hr',
  BlockingRoad = '12 hrs',
  OvercrowdedParkingBay = '12 hrs',
  SomethingElse = '1 hr',
}
